module.exports = __webpack_public_path__ + "img/manufacture.6b17e02.jpg";